import React from "react";
import Helper from "./../../../extra/helper";

function ExportProviderTable(props) {
  const renderStatusText = (statusId, defaultStatus) => {
    switch (+statusId) {
      case 1:
        return "Chưa thanh toán";
      case 2:
        return "Đã thanh toán";
      case 3:
        return "Hoàn thành";
      case 4:
        return "Đơn huỷ";
      case 5:
        return "Lỗi thanh toán";
      case 7:
        return "Lỗi cấp GCN";
      case 8:
        return "Chờ thẩm định";
      case 10:
        return "Chờ GCN";
      case 11:
        return "Từ chối";
      default:
        return defaultStatus || "-";
    }
  };

  return (
    <div style={{ display: "none" }}>
      <table
        className="collapse-border"
        id={"report"}
        data-cols-width={
          props?.acountGC
            ? "10, 30, 30, 30, 20, 40, 40, 25, 25, 25, 20, 20"
            : "10, 30, 30, 30, 20, 40, 40, 25, 25, 25, 20"
        }
        border={"1px solid red"}
      >
        <thead style={{ fontSize: "13" }}>
          <tr>
            <th
              colSpan={props?.acountGC ? 12 : 11}
              data-f-name={"Times new roman"}
              data-f-sz={"24"}
              data-a-wrap={true}
              data-a-h={"center"}
              data-f-bold={true}
            >
              Quản lý đơn
            </th>
          </tr>
          <tr>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>STT</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Mã giỏ hàng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Mã đơn hàng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Chủ hợp đồng</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Số điện thoại</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Đối tượng được BH</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Tên Sản phẩm</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Phí bảo hiểm</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Ngày tạo</th>
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Ngày cấp GCN</th>
            {props?.acountGC && (
              <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Mã CTV</th>
            )}
            <th data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"} data-f-bold={true}>Trạng thái</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: "13" }}>
          {props?.data?.map((item, index) => {
            return (
              <tr key={index} style={{ fontSize: "13" }}>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{index + 1}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.transCode || item?.transaction_code || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.orderCode || item?.code || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyerName || item?.buyer_name || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.buyerPhone || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.insuredAddress || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.productTitle || "-"}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{Helper._formatMoney2(item?.fees)}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.createdDate || (item?.created_date ? Helper._formatDay(item.created_date) : "-")}</td>
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.certIssueAt || "-"}</td>
                {props?.acountGC && (
                  <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{item?.extra_info?.referalCode || "-"}</td>
                )}
                <td data-f-name={"Times new roman"} data-f-sz={"16"} data-b-a-s={"thin"}>{renderStatusText(item?.statusId, item?.status)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(ExportProviderTable);
